<footer class="footer">
  <div class="footer-container">

    <div class="footer-content">
      <div class="footer-logo">
        <img
          src="https://res.cloudinary.com/tatikka/image/upload/f_webp/v1768858404/Logo-Niadcon-Consorcios-Branco_sdzny9.png"
          alt="Logo" width="140" height="50">
      </div>
      <div class="footer-text">
        <p>
          &copy; NIADCON CORRETORA DE SEGUROS E IMOVEIS LTDA<br>
          CNPJ 51.954.237/0001-42<br>
          AV. WALDEMAR CARLOS PEREIRA, 887 - Sala 11 - Vila Talarico - São Paulo - SP
        </p>
        <p>Representante autorizado da Administradora Porto Bank, fiscalizada pelo Banco Central do Brasil.</p>
        <p class="legal-links">
          <a routerLink="/politica-de-privacidade">Política de Privacidade</a> |
          <a routerLink="/termos-de-uso">Termos de Uso</a>
        </p>
      </div>
      <div class="footer-contact">
        <p>Central de Atendimento Niadcon</p>
        <p><a href="tel:+551120504932">(11) 2050-4932</a></p>
      </div>
    </div>

  </div>
</footer>